"use strict";
var Observable_1 = require('../../Observable');
var switchMap_1 = require('../../operator/switchMap');
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/rxjs/add/operator/switchMap.js
// module id = Pic8
// module chunks = 6